// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 268) return "js/deco/268.js";
	if (chunkId === 725) return "js/deco/725.js";
	// return url for filenames based on template
	return undefined;
};